<template>
	<div>
		<b-overlay :show="loading" rounded="sm">
			<div class="hide-print p-3 row">
				<div class="col text-left">
					<b-button @click="$router.go(-1)" variant="outline-dark">{{ $t('back') }}</b-button>
				</div>
				<div class="col text-right">
					<b-button @click="print" variant="dark">{{ $t('pricing.print') }}</b-button>
				</div>
			</div>
			<b-card>
				<div class="row">
					<div class="col">DutyFree International</div>
					<div class="col text-center">
						<h5><b>Договор - {{ form.contractNumber }}</b></h5>
					</div>
					<div class="col" />
				</div>
				<b-row class="mt-3">
					<b-col cols="4">
						<b>{{ $t('promo-to-product.regDate') }}: </b> <span> {{ form.contractDate }}</span>
						<br>
						<b>Форма контракта: </b> <span> {{ form.contractType == '1' ? 'Генеральный' : 'Одноразовый' }}</span>
						<br>
						<b>Ответственный: </b> <span> {{ form.newContractManagement.employee.firstName + ' ' +
							form.newContractManagement.employee.lastName + ' ' +
							form.newContractManagement.employee.middleName }}</span>
					</b-col>
					<b-col cols="4">
						<b>Тип контракта: </b> <span> {{ form.newContractManagement.type.name }}</span>
						<br>
						<b>Тип контрагента: </b> <span> {{ form.newContractManagement.stage.name }}</span>
						<br>
						<b>Контрагент: </b> <span> {{ form.newContractManagement.contragent.fullName }}</span>
					</b-col>
					<b-col cols="4">
						<b>Срок окончания: </b> <span> {{ form.endDate }}</span>
						<br>
						<b>Примечание: </b> <span> {{ form.reason }}</span>
						<br>
						<b>Общая сумма: </b> <span>{{ form.amountPriceUzs }}</span>
					</b-col>
				</b-row>
				<b-row class="mt-3" v-if="form.contractItems && form.contractItems.length > 0">
					<b-col>
						<b-table :items="form.contractItems" :fields="itemFields" hover striped bordered show-empty
							ref="itemTable">
							<template slot="empty" slot-scope="scope">
								<h4 class="text-center">{{ $t('empty') }}</h4>
							</template>
							<template slot="id" slot-scope="data">
								{{ data.index + 1 }}
							</template>
							<template slot="multiBarcode" slot-scope="data">
								<div v-for="b in data.item.multiBarcodes">{{ b.barcode }}</div>
							</template>
							<template slot="incomingPriceUzs" slot-scope="data">
								{{ data.item.incomingPriceUzs | currency({
									symbol: '', fractionCount: 2, symbolPosition:
										'back', thousandsSeparator: ' '}) }}
							</template>
							<template slot="amount" slot-scope="data">
								{{ (data.item.count * data.item.incomingPriceUzs) | currency({
									symbol: '', fractionCount:
										2, symbolPosition: 'back', thousandsSeparator: ' '}) }}
							</template>
						</b-table>
					</b-col>
				</b-row>
				<b-row class="mt-3">
					<b-col>
						<table class="table table-hover table-striped table-bordered">
							<thead>
								<tr>
									<th class="text-center">№</th>
									<th class="text-center" style="width: 33%">%</th>
									<th class="text-center" style="width: 33%">{{
										form.newContractManagement.currency.name }}</th>
									<th class="text-center" style="width: 33%">Срок окончания</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(pay, index) in form.payments" :key="`pay-view-${index}`">
									<td class="text-center">{{ index + 1 }}</td>
									<td class="text-center">{{ pay.percentage }}</td>
									<td class="text-center">{{ pay.price | currency({
										symbol: '', fractionCount: 2,
										symbolPosition:
											'back', thousandsSeparator: ' '}) }}</td>
									<td class="text-center">{{ pay.date }}</td>
								</tr>
							</tbody>
						</table>
					</b-col>
				</b-row>
				<b-row class="mt-3">
					<b-col cols="4" v-for="(file, index) in files" :key="`file-view-${index}`" v-if="file">
						<b-card style="min-height: 70px; position: relative">
							<b-row>
								<b-col cols="2">
									<img v-if="file.contentType === '.xls' || file.contentType === '.xlsx'"
										src="../../assets/file-img/excel.png" style="width: 60px; height: 60px">
									<img v-if="file.contentType === '.doc' || file.contentType === '.docx'"
										src="../../assets/file-img/word.png" style="width: 60px; height: 60px">
									<img v-if="file.contentType === '.pdf'" src="../../assets/file-img/pdf.png"
										style="width: 60px; height: 60px">
								</b-col>
								<b-col>
									<p class="ml-2">{{ file.fileName }}</p>
								</b-col>
							</b-row>
							<a :href="file.url" download class="badge badge-primary hide-print"
								style="position: absolute; right: -10px; bottom: -10px; font-size: 18px; cursor: pointer"><i
									class="fa fa-download" /></a>
						</b-card>
					</b-col>
				</b-row>
			</b-card>
		</b-overlay>
	</div>
</template>

<script>
import { BOverlay } from 'bootstrapVue2';
import ContractService from "./contract.service";

export default {
	name: "doc-view",
	components: { BOverlay },
	data() {
		return {
			loading: false,
			form: {},
			files: [],
			itemFields: [
				{ key: 'id', label: '№', class: 'text-center' },
				{ key: 'barcode', label: this.$t("goods.special-barcode"), class: 'text-center' },
				{ key: 'name', label: this.$t("goods.name") },
				{ key: 'multiBarcode', label: this.$t("goods.barcode"), class: 'text-center' },
				{ key: 'incomingPriceUzs', label: this.$t("incomes.create.price"), class: 'text-center' },
				{ key: 'count', label: this.$t("sale.kol-vo"), class: 'text-center' },
				{ key: 'amount', label: this.$t("Сумма"), class: 'text-center' },
				{ key: 'action', label: this.$t(""), class: 'text-center' }
			]
		}
	},
	methods: {
		print() {
			window.print();
		}
	},
	async created() {
		this.loading = true
		await ContractService.getContractById(this.$route.params.id).then(res => {
			this.form = res.data.contract
			this.files = res.data.files
			this.loading = false
		}).catch(e => {
			this.loading = false
			this.$vs.notify({
				title: e.message,
				color: 'danger',
				icon: 'close',
				position: 'top-right'
			});
		})
	}
}
</script>

<style scoped>
@media print {
	.hide-print {
		display: none;
	}
}
</style>
